export const SET_NEO4J_AUTH = "SET_NEO4J_AUTH"

export const UPDATE_NEOVIS_ENTITY = "UPDATE_NEOVIS_ENTITY"
export const UPDATE_NEOVIS_RELATION = "UPDATE_NEOVIS_RELATION"
export const RESET_NEOVIS_OPTIONS = "RESET_NEOVIS_OPTIONS"
